export const common = {
  apiUrl: CONFIG.apiPath
}
